import { Link } from 'react-router-dom';
import { useOffers } from '../../context/OffersContext';
import { offerHowItWorks } from '../../utils/offerMatch';
const GiftIcon = ({ className }) => <span className={`${className} inline-flex items-center justify-center`} aria-hidden="true">🎁</span>;
const ArrowRight = ({ className }) => <span className={className} aria-hidden="true">→</span>;

/** Home page: the store's current offers, each linking to its product list. Nothing when there are none. */
const OfferBanner = () => {
  const { offers, sym } = useOffers();
  if (!offers.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8" aria-label="Current offers" data-testid="offer-banner">
      <div className={`grid gap-3 md:gap-4 ${offers.length > 1 ? 'md:grid-cols-2' : ''}`}>
        {offers.slice(0, 4).map((o) => (
          <Link key={o.code} to={`/offers/${encodeURIComponent(o.code)}`}
            className="group flex items-center gap-4 rounded-2xl text-white px-5 py-5 md:px-7 md:py-6 bg-gradient-to-r from-primary-dark to-accent shadow-card hover:shadow-card-hover transition-shadow">
            <GiftIcon className="w-8 h-8 text-white shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-lg md:text-xl font-bold leading-tight">{o.title}</p>
              <p className="text-[13px] text-white/80 mt-1">{offerHowItWorks(o, sym)}</p>
            </div>
            <span className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap">
              Shop now <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OfferBanner;
